<template>
    <div :id="modalId" uk-modal>
        <div class="uk-modal-dialog uk-modal-body">
            <h2 class="uk-modal-title">{{title}}</h2>
            <form ref="form" class="">
                <slot></slot>
            </form>
            <button class="uk-button uk-button-primary uk-modal-close" type="button" @click="submitForm()">Finish</button>
            <button class="uk-button uk-button-tertiary uk-modal-close" type="button" @click="cancel()">Cancel</button>
        </div>
    </div>
</template>
<script>
    import EventBus from "../events";
    export default {

        props: {
            modalId:String,
            title:String,
            post:String,
            table:{
                type: String,
                default: null
            },
            get:String,
            checkboxGroups:{
                type:Array,
                default:() => []
            },
            checkboxes:{
                type:Array,
                default:() => []
            },
            successMessage: {
                type: String,
                default: "Update Successful."
            },
            failureMessage: {
                type: String,
                default: "Update Failed."
            }
        },

        data(){
            return {
                id:null,
            }
        },

        mounted(){

        },

        methods: {
            submitForm() {
                let data = new FormData(this.$refs.form);
                let uri = this.post;
                if(this.id !== null){
                    uri = this.ensureEndingSlash(uri) + this.id.toString();
                }
                axios.post(uri, data)
                    .then((pack) => this.updateForm(pack))
                    .catch(error => this.reportFailures(error));
            },
            cancel() {
                this.clearForm();
            },
            updateForm(pack){
                this.clearForm();
                if(this.table){
                    this.$root.$refs[this.table].startSearch();
                }
                if(pack.data.success){
                    EventBus.fireEvent("message", this.successMessage);
                } else {
                    EventBus.fireEvent("error", this.failureMessage);
                }
            },
            reportFailures(error){
                console.log(error.response.data.errors);
                EventBus.fireEvent("error", this.failureMessage);
                for(let field in error.response.data.errors){
                    EventBus.fireEvent("error", error.response.data.errors[field][0]);
                }
            },
            clearForm(){
                if(this.id){
                    this.id = null;
                    this.$refs.form.reset();
                }
            },
            loadForm(id){
                this.id = id;
                axios.get(this.ensureEndingSlash(this.get) + id).then((pack) => this.updateFormData(pack));
            },
            updateFormData(pack){
                let data = pack.data.data;

                for(let name in data){
                    let field = this.$refs.form.querySelector("*[name="+name+"]");
                    if(field){
                        field.value = data[name];
                    }
                }
                //for groups of checkboxes that send an array of values
                for(let i = 0; i < this.checkboxGroups.length;++i){
                    let group = this.checkboxGroups[i];
                    let boxes = this.$refs.form.querySelectorAll("*[name='"+group.fieldName+"']");
                    let boxData = data[group.dataName];
                    //looping through the boxes that show
                    for(let j = 0; j < boxes.length; ++j){
                        let box = boxes[j];
                        for(let k = 0; k < boxData.length;++k){
                            let dt = boxData[k];
                            if(dt.id == box.value){
                                box.checked = true;
                                break;
                            }
                        }
                    }
                }
            },
            ensureEndingSlash(str){
                let lastChar = str.substr(str.length - 1);
                if(lastChar != "/"){
                    return str + "/";
                }
                return str;
            }
        }

    }
</script>
